import { toISODate } from "./isoDate"

/** Last 7 calendar days ending yesterday (inclusive). */
export function defaultPayrollRange(today = new Date()): { from: string, to: string } {
  const end = new Date(today.getFullYear(), today.getMonth(), today.getDate() - 1)
  const start = new Date(end.getFullYear(), end.getMonth(), end.getDate() - 6)
  return { from: toISODate(start), to: toISODate(end) }
}

export function isValidPayrollRange(from: string, to: string): boolean {
  return Boolean(from && to && from <= to)
}

export function parseContentDispositionFilename(header?: string | null): string | null {
  if (!header) return null
  const utf = header.match(/filename\*=(?:UTF-8''|utf-8'')([^;]+)/i)
  if (utf?.[1]) {
    try {
      return decodeURIComponent(utf[1].trim().replace(/^["']|["']$/g, ""))
    } catch {
      return utf[1].trim().replace(/^["']|["']$/g, "")
    }
  }
  const plain = header.match(/filename=([^;]+)/i)
  if (plain?.[1]) {
    return plain[1].trim().replace(/^["']|["']$/g, "")
  }
  return null
}

export function payrollFilenameFallback(companyCode: string, from: string, to: string, format: "csv" | "xlsx"): string {
  const code = (companyCode || "CW").trim().toUpperCase() || "CW"
  return `${code}_PRDAILY_${from}_${to}.${format}`
}
